
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
export default function getOverlayAlpha(elevation: number): number {
  let alphaValue
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2
  }
  return +(alphaValue / 100).toFixed(2)
}
